module.exports = __webpack_public_path__ + "img/ntbc.94770d73.svg";